<template>
  <v-container fluid>
    <v-card :loading="loading || loadingDocumentos">
      <v-card-title>
        <h2>
          <v-btn
            class="mx-2"
            icon
            text
            small
            :to="{ name: 'pacote-documento-list' }"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <span v-if="!pacote">Carregando...</span>
          <template v-else>
            Pacote de documentos: {{ pacote.titulo }}
          </template>
        </h2>
      </v-card-title>
      <v-card-text class="pt-5" v-if="pacote">
        <h3>Informações do pacote</h3>
        <v-row align="center">
          <v-col>
            <span class="caption">Cliente</span><br />
            <b>{{ pacote.cliente.nome }}</b
            ><span
              v-if="pacote.cliente.razao_social != ''"
              class="text--disabled"
            >
              - {{ pacote.cliente.razao_social }}</span
            >
          </v-col>
          <v-col>
            <v-icon
              :class="
                pacote.enviado
                  ? 'mdi mdi-checkbox-marked-outline'
                  : 'mdi mdi-checkbox-blank-outline'
              "
            />
            {{ pacote.enviado ? "Pacote enviado" : "Pacote não enviado" }}
          </v-col>
        </v-row>
        <p>{{ pacote.descricao }}</p>
        <div class="mt-5">
          <h2>Documentos do pacote</h2>
          <div class="mt-5">
            <seletor-email
              tipo-entidade="clientes"
              :id-entidade="pacote.id_cliente"
              v-if="perms.includes('documentos.enviar_pacotes')"
              @confirmar="enviarPacoteCliente($event)"
            >
              <v-btn
                color="primary"
                outlined
                small
                :loading="enviando"
                v-if="Object.keys(grupos).length > 0"
              >
                <v-icon class="mr-2" small>mdi-send</v-icon>
                ENVIAR PACOTE POR EMAIL
              </v-btn>
            </seletor-email>
            <v-btn
              color="primary"
              outlined
              small
              class="ml-3"
              :loading="downloading"
              @click="download()"
              v-if="Object.keys(grupos).length > 0"
            >
              <v-icon class="mr-2" small>mdi-download</v-icon>
              DOWNLOAD DO PACOTE ({{ stringTamanho() }})
            </v-btn>
            <v-menu
              offset-y
              v-if="perms.includes('documentos.editar_pacotes')"
              v-model="menu"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  outlined
                  color="primary"
                  class="ml-3"
                  v-on="on"
                  v-bind="attrs"
                >
                  <v-icon small class="mr-2">mdi-plus</v-icon>
                  DOCUMENTOS
                  <v-icon small class="ml-2">mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list v-if="proprietarios">
                <seletor-documento
                  v-for="(proprietario, i) in proprietarios"
                  :key="`proprietario-${i}`"
                  :tipoProprietario="proprietario"
                  :mudarProprietario="true"
                  :alterar="true"
                  @selecionar="selecionarDocumentos($event)"
                >
                  <v-list-item @click="menu = false">
                    <v-list-item-content>
                      <v-list-item-title>{{
                        proprietario.descricao
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </seletor-documento>
              </v-list>
            </v-menu>
          </div>
        </div>
        <v-list v-if="Object.keys(grupos).length > 0" two-line>
          <template v-for="(grupo, i) in grupos">
            <v-subheader :key="`subheader-${i}`" class="px-0">{{
              grupo.tipo_proprietario.descricao
            }}</v-subheader>
            <seletor-documento
              v-for="(proprietario, j) in grupo.proprietarios"
              :key="`proprietario-${i}-${j}`"
              :id-proprietario="proprietario.id"
              :tipoProprietario="grupo.tipo_proprietario"
              :mudarProprietario="false"
              :documentos-selecionados="proprietario.documentosSelecionados"
              :alterar="perms.includes('documentos.editar_pacotes')"
              @selecionar="selecionarDocumentos($event)"
            >
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-list-item-subtitle>
                    {{ proprietario.codigo }}
                  </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ proprietario.titulo }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action
                  v-if="
                    !pacote.enviado &&
                      perms.includes('documentos.editar_pacotes')
                  "
                >
                  <v-btn icon @click.stop="removerProprietario(proprietario)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </seletor-documento>
          </template>
        </v-list>
        <v-alert v-else type="info" class="mt-5"
          >Nenhum documento no pacote</v-alert
        >
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import SeletorDocumento from "../components/documentos/SeletorDocumento";
import SeletorEmail from "../components/contatos/SeletorEmail";
import moment from "moment";
import formatBytes from "../lib/format_bytes";
export default {
  components: {
    SeletorDocumento,
    SeletorEmail,
  },
  data() {
    return {
      pacote: null,
      loading: false,
      menu: false,
      loadingDocumentos: false,
      grupos: {},
      downloading: false,
      enviando: false,
      tamanhoPacote: 0,
    };
  },
  computed: {
    ...mapState({
      proprietarios: (state) => state.documento.tiposProprietario,
      perms: (state) => state.usuarios.usuarioAtivo.permissoes,
    }),
  },
  async mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Pacotes de documentos",
    });
    this.loading = true;

    await this.$store.dispatch("documento/listarTiposProprietario");

    this.carregarDocumentos();
  },
  methods: {
    async carregarDocumentos() {
      const id = this.$route.params.id;
      this.loading = true;
      try {
        this.pacote = await this.$store.dispatch(
          "documento/carregarPacote",
          id
        );
        const documentos = await this.$store.dispatch(
          "documento/documentosPacote",
          id
        );
        this.grupos = {};
        documentos.map((documento) => {
          if (!this.grupos[documento.tipo_proprietario.servico]) {
            this.grupos[documento.tipo_proprietario.servico] = {
              tipo_proprietario: documento.tipo_proprietario,
              proprietarios: [],
            };
          }
          const proprietario = this.grupos[
            documento.tipo_proprietario.servico
          ].proprietarios.find((p) => p.id === documento.proprietario.id);
          if (!proprietario) {
            this.grupos[documento.tipo_proprietario.servico].proprietarios.push(
              {
                id: documento.proprietario.id,
                codigo:
                  documento.proprietario[
                    documento.tipo_proprietario.campo_codigo
                  ],
                titulo:
                  documento.proprietario[
                    documento.tipo_proprietario.campo_titulo
                  ],
                tipo_proprietario: documento.tipo_proprietario,
                documentosSelecionados: [documento.id],
              }
            );
          } else {
            proprietario.documentosSelecionados.push(documento.id);
          }
          return documento;
        });

        if (documentos.length > 0) {
          const response = await this.$store.dispatch(
            "documento/tamanhoPacote",
            id
          );
          this.tamanhoPacote = response.tamanho;
        }
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar o pacote de documentos",
        });
      }
      this.loading = false;
    },
    async selecionarDocumentos(selecao) {
      this.loadingDocumentos = true;
      try {
        await this.$store.dispatch("documento/adicionarDocumentosPacote", {
          id_pacote: this.pacote.id,
          selecao,
        });
        this.carregarDocumentos();
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível adicionar os documentos ao pacote",
        });
      }
      this.loadingDocumentos = false;
    },
    async removerProprietario(proprietario) {
      try {
        await this.$store.dispatch("documento/removerProprietarioPacote", {
          id_pacote: this.pacote.id,
          id_tipo_proprietario: proprietario.tipo_proprietario.id,
          id_proprietario: proprietario.id,
        });
        this.carregarDocumentos();
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível remover os documentos do pacote",
        });
      }
    },
    dataValidade(doc) {
      if (doc.data_validade === "") return "-";
      return moment(doc.data_validade).format("DD/MM/YYYY");
    },
    async download() {
      this.downloading = true;
      try {
        const response = await this.$store.dispatch(
          "documento/downloadPacote",
          this.pacote.id
        );
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: response.data.type })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (e) {
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível realizar o download do pacote",
        });
      }
      this.downloading = false;
    },
    async enviarPacoteCliente(emails) {
      this.enviando = true;
      try {
        await this.$store.dispatch("email/pacoteDocumentos", {
          id_pacote: this.pacote.id,
          emails,
        });
        this.$store.commit("ui/setSnackbar", {
          text: "Email enviado com sucesso",
          color: "success",
        });
        this.pacote.enviado = true;
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível enviar o email ao cliente",
        });
      }
      this.enviando = false;
    },
    stringTamanho() {
      return formatBytes(this.tamanhoPacote);
    },
  },
};
</script>
